import { utils } from "../core/helpers"
import en from "./en"
import tr from "./tr"

export const languages = {
    en,
    tr
}

const getTranslatedText = (string, locale) => {
    let curLocale = utils.getStore("locale")
    if (!curLocale) {
        utils.setStore("locale", "en")
        curLocale = "en"
    }
    const curTranslation = languages[locale] ?? languages[curLocale] ?? languages["en"]
    return curTranslation[string] ?? string
}

export { getTranslatedText }
